import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisonRows = [{
  situation: 'Alumno con artrosis de rodilla',
  sin: 'Improvisás o evitás trabajar con él',
  con: 'Protocolo exacto: qué hacer, qué no hacer, qué decir'
}, {
  situation: 'Alumno con osteoporosis',
  sin: 'No sabés qué está contraindicado',
  con: 'Lista de restricciones y ejercicios adaptados por condición'
}, {
  situation: 'Alumno con hipertensión',
  sin: 'Miedo a una crisis durante la clase',
  con: 'Guía de intensidad y señales de alerta por condición'
}, {
  situation: 'Alumno con Parkinson leve',
  sin: 'Evitás todo por las dudas',
  con: 'Protocolo claro de qué sí y qué no según el estadío'
}, {
  situation: 'Situación de urgencia o caída',
  sin: 'Pánico y sin saber qué hacer',
  con: 'Protocolo de emergencia paso a paso listo para usar'
}, {
  situation: 'Alumno nuevo con condición especial',
  sin: 'La ficha no te dice qué hacer',
  con: 'Tabla de equivalencias: si el alumno tiene X, hacé Y'
}];
const modules = [{
  icon: '🦴',
  title: 'Módulo 1',
  desc: 'Columna y Postura'
}, {
  icon: '🦵',
  title: 'Módulo 2',
  desc: 'Miembros Inferiores y Caídas'
}, {
  icon: '💪',
  title: 'Módulo 3',
  desc: 'Miembros Superiores'
}, {
  icon: '❤️',
  title: 'Módulo 4',
  desc: 'Condiciones Cardiovasculares y Metabólicas'
}, {
  icon: '🧠',
  title: 'Módulo 5',
  desc: 'Condiciones Neurológicas y Cognitivas'
}, {
  icon: '🚨',
  title: 'Módulo 6',
  desc: 'Protocolos de Seguridad y Emergencia'
}];
export function PatologiasPro() {
  return <section className="py-10 md:py-20 px-4 bg-navy-50" data-id="element-171">
      <div className="max-w-5xl mx-auto" data-id="element-172">
        <div className="text-center mb-6 md:mb-12" data-id="element-173">
          <h2 className="font-display text-3xl md:text-5xl text-navy-900 uppercase tracking-wide mb-4" data-id="element-174">
            ¿QUÉ AGREGA EL PATOLOGÍAS PRO™?
          </h2>
          <p className="text-xl text-navy-600 font-medium" data-id="element-175">
            El sistema de adaptaciones que hace que ningún alumno sea "demasiado
            difícil"
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-navy-100 overflow-hidden mb-8 md:mb-16" data-id="element-176">
          <div className="overflow-x-auto" data-id="element-177">
            <table className="w-full min-w-[700px]" data-id="element-178">
              <thead data-id="element-179">
                <tr className="bg-navy-900 text-white" data-id="element-180">
                  <th className="py-4 px-6 text-left font-bold w-1/3" data-id="element-181">
                    Situación
                  </th>
                  <th className="py-4 px-6 text-left font-bold w-1/3 bg-red-900/20" data-id="element-182">
                    Sin Patologías Pro
                  </th>
                  <th className="py-4 px-6 text-left font-bold w-1/3 bg-green-900/20 text-gold" data-id="element-183">
                    Con Patologías Pro
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-navy-100" data-id="element-184">
                {comparisonRows.map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-navy-50/50'} data-id="element-185">
                    <td className="py-4 px-6 text-navy-900 font-medium" data-id="element-186">
                      {row.situation}
                    </td>
                    <td className="py-4 px-6 text-navy-600" data-id="element-187">
                      <div className="flex items-start gap-2" data-id="element-188">
                        <X className="text-danger shrink-0 mt-0.5" size={18} data-id="element-189" />
                        <span data-id="element-190">{row.sin}</span>
                      </div>
                    </td>
                    <td className="py-4 px-6 text-navy-900 font-bold bg-green-50/30" data-id="element-191">
                      <div className="flex items-start gap-2" data-id="element-192">
                        <Check className="text-green-600 shrink-0 mt-0.5" size={18} data-id="element-193" />
                        <span data-id="element-194">{row.con}</span>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mb-10" data-id="element-195">
          <h3 className="text-2xl font-bold text-navy-900" data-id="element-196">
            PATOLOGÍAS PRO™ INCLUYE:
          </h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-197">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-xl border border-navy-100 flex items-center gap-4 shadow-sm" data-id="element-198">
              <div className="text-4xl" data-id="element-199">{mod.icon}</div>
              <div data-id="element-200">
                <div className="text-sm font-bold text-gold uppercase tracking-wider" data-id="element-201">
                  {mod.title}
                </div>
                <div className="font-bold text-navy-900" data-id="element-202">{mod.desc}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}